import { HttpParams } from '@angular/common/http';

export const createRequestOption = (req?: any): HttpParams => {
  let options: HttpParams = new HttpParams();
  if (req) {
    Object.keys(req).forEach(key => {
      if (key !== 'sort') {
        options = options.set(key, req[key]);
      }
    });
    if (req.sort) {
      let sortValue = '';
      req.sort.forEach((val: any) => {
        sortValue += val + ',';
      });
      options = options.set(
        'sort',
        sortValue.substring(0, sortValue.length - 1),
      );
    }
  }
  return options;
};

export const createRequestOptionCriteria = (req?: any): HttpParams => {
  let options: HttpParams = new HttpParams();
  if (req) {
    Object.keys(req).forEach(key => {
      if (key !== 'sort') {
        let obj = req[key];
        if (obj !== null) {
          if (obj === Object(req[key]) && 'tipo' in obj) {
            options = options.set(
              key + (obj ? '.' + obj.tipo : obj.tipo),
              obj.valor,
            );
          } else {
            if (!Array.isArray(obj)) {
              options = options.set(key + '.equals', obj);
            } else {
              obj.forEach(el => {
                const objEl = el;
                if ('tipo' in objEl) {
                  options = options.set(
                    key + (obj ? '.' + objEl.tipo : objEl.tipo),
                    objEl.valor,
                  );
                } else {
                  options = options.set(key, obj);
                }
              });
            }
          }
        }
      }
      if (req.sort) {
        let sortValue = '';
        req.sort.forEach((val: any) => {
          sortValue += val + ',';
        });
        options = options.set(
          'sort',
          sortValue.substring(0, sortValue.length - 1),
        );
      }
    });
  }
  return options;
};

export const createRequestOptionAndCriteria = (
  req?: any,
  params?: any,
): HttpParams => {
  let options: HttpParams = new HttpParams();
  if (req) {
    Object.keys(req).forEach(key => {
      if (key !== 'sort') {
        options = options.set(key, req[key]);
      }
    });
    if (req.sort) {
      req.sort.forEach((val: any) => {
        options = options.append('sort', val);
      });
    }
  }
  if (params) {
    Object.keys(params).forEach(key => {
      if (key !== 'sort') {
        let obj = params[key];
        if (obj) {
          if (obj === Object(params[key]) && 'tipo' in obj) {
            if (Array.isArray(obj.valor)) {
              obj.valor.forEach((val: any) => {
                options = options.set(
                  key + (obj ? '.' + obj.tipo : obj.tipo),
                  val,
                );
              });
            } else {
              options = options.set(
                key + (obj ? '.' + obj.tipo : obj.tipo),
                obj.valor,
              );
            }
          } else {
            if (!Array.isArray(obj)) {
              options = options.set(key + '.equals', obj);
            } else {
              obj.forEach(el => {
                options = options.set(key, obj);
              });
            }
          }
        }
      }
    });
  }
  return options;
};
